import $ from 'jquery';

export default function customScript() {
    const menuOpen = '#menuOpen';
    const menuclick = '#menuclick';
  
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 200) {
        $("#headerScroll").addClass("scrollclass");
      } else {
        $("#headerScroll").removeClass("scrollclass");
      }
    });

$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 215) {
        $("#tabsFixed").addClass("tabsfixed");
    } else {
        $("#tabsFixed").removeClass("tabsfixed");
    }
});

$('#navclick').click(function(){
    $(mainContainer).toggleClass('menu-slide');
    $(clickmenu).toggleClass('menu-slide');
});

$(".button").click(() => {
    $("selector").addClass("popshow");
});


$(document).on('click', '.flip-card', function() {
    $('.flip-card').removeClass('active');
    $(this).addClass('active');
  });

$('#searchclick').click(function(){
    $(searchOpen).toggleClass('open-search');
   
});

$('#receiverClick').click(function(){
    $(receiver).toggleClass('receivershow');
   
});

$(document).on('click', '#menuclick', function () {
    $(menuOpen).toggleClass("show-menu");
    $(menuclick).toggleClass("close-menu");
  });


$('#readMoewa').click(function(){
    $(readMoewaa).toggleClass('showcontent');
    $('#readMoewa').html("<< Show Less");
});

$('#readMoewb').click(function(){
    $(readMoewbb).toggleClass('showcontent');
    $('#readMoewb').html("<< Show Less");
});
$('#readMoewc').click(function(){
    $(readMoewcc).toggleClass('showcontent');
    $('#readMoewc').html("<< Show Less");
});
$('#readMoewd').click(function(){
    $(readMoewdd).toggleClass('showcontent');
    $('#readMoewd').html("<< Show Less");
});
$('#readMoewe').click(function(){
    $(readMoewee).toggleClass('showcontent');
    $('#readMoewe').html("<< Show Less");
});
$('#readMoewf').click(function(){
    $(readMoewff).toggleClass('showcontent');
    $('#readMoewf').html("<< Show Less");
});

// For Admin

$("#leftMenuSlide").click(function () {
    $("#leftMenuSlideBox").toggleClass("slide-menu");
    $(".have-item").removeClass("submenu-show");
    
});

$("#leftMenuSlideTop").click(function () {
    $("#leftMenuSlideBox").toggleClass("slide-menu");
    $("#leftMenuSlideTop").toggleClass("close-menu-icon");
}); 

$(".adminSubMenu").click(function (event) {
    event.preventDefault();
    $(".adminSubMenu").not(this).parent().removeClass("submenu-show");
    $(this).parent().toggleClass("submenu-show");
    $("#leftMenuSlideTop").addClass("close-menu-icon");
  });

$(".admin-add-btn").click(function () {
    $(".add-new-section").toggleClass("show-section");
}); 
$(".add-new-cancel").click(function () {
    $(".add-new-section").toggleClass("show-section");
}); 

$(document).on('click', '.editBtn', function(e) {
    e.preventDefault();
    $('.admin-item-box').removeClass('show-edit-item');
    $(this).closest('.admin-item-box').addClass('show-edit-item');
    $(this).closest('.admin-item-list-section').addClass('show-edit-item-outer');
  });

$(document).on('click', '.addNewCancel', function(e) {
    e.preventDefault();
    $(this).closest('.admin-item-list-section').removeClass('show-edit-item-outer');
    $(this).closest('.admin-item-box').removeClass('show-edit-item');
});

// $(document).on("click", ".tags-edit-btn", function (e) {
//   e.preventDefault();
//   $(".email-tags-box").removeClass("tags-editable");
//   $(this).closest(".email-tags-box").addClass("tags-editable");
// });

// $(document).on("click", ".tags-edit-save-btn", function (e) {
//   e.preventDefault();
//   $(".email-tags-box").removeClass("tags-editable");
//   $(this).closest(".email-tags-box").removeClass("tags-editable");
// });

// $(document).on("click", "#deleteEmailTagEditBtn", function (e) {
//   e.preventDefault();
//   $(".email-tags-box").removeClass("tags-editable");
//   $(this).closest(".email-tags-box").removeClass("tags-editable");
// });
//

// $(document).on("click", ".lmd-custom-select-box-btn", function (e) {
//   e.preventDefault();

//   // Close all boxes first
//   $(".lmd-custom-select-box").removeClass("lmd-custom-select-box-show");

//   // Open only the clicked one
//   $(this)
//     .closest(".lmd-custom-select-box")
//     .addClass("lmd-custom-select-box-show");

//   // Stop propagation so the document click doesn't immediately close it
//   e.stopPropagation();
// });

// // Prevent inner elements from triggering document click
// $(document).on("click", ".lmd-custom-select-box", function (e) {
//   e.stopPropagation();
// });

// // Close when clicking outside
// $(document).on("click", function () {
//   $(".lmd-custom-select-box").removeClass("lmd-custom-select-box-show");
// });


// For Join Our Team
// $(document).on("click", ".collapse-btn", function (e) {
//   e.preventDefault();
//   const $currentBox = $(this).closest(".join-team-tabs-box");
//   $(".join-team-tabs-box.tabs-open").not($currentBox).removeClass("tabs-open");
//   $currentBox.toggleClass("tabs-open");
// });

$(document).on('click', '.hide-row-btn', function(e) {
    e.preventDefault();
    $('.admin-item-box').removeClass('show-edit-item');
});

// $(function () {
//     $('[data-bs-toggle="tooltip"]').tooltip()
//   })
  
  $(document).on('click', '.viewbtn', function(e) {
    e.preventDefault();
    $('.admin-item-box').removeClass('show-edit-item');
    $(this).closest('.admin-item-box').addClass('show-edit-item');
    $(this).closest('.admin-item-list-section').addClass('show-edit-item-outer');
  })

  $(document).on('click', '.viewclose', function(e) {
    e.preventDefault();
    $(this).closest('.admin-item-list-section').removeClass('show-edit-item-outer');
    $(this).closest('.admin-item-box').removeClass('show-edit-item');
});



var selectBox = document.querySelector('.statusselectbox');
if (selectBox) {
    function updateStyles() {
        var selectedValue = selectBox.value;

        switch (selectedValue) {
            case 'new':
                selectBox.style.borderColor = '#946CCF';
                selectBox.style.color = '#946CCF';
                break;
            case 'followup':
                selectBox.style.borderColor = '#FDA900';
                selectBox.style.color = '#FDA900';
                break;
            case 'hired':
                selectBox.style.borderColor = '#5BC770';
                selectBox.style.color = '#5BC770';
                break;
            case 'rejected':
                selectBox.style.borderColor = 'red';
                selectBox.style.color = 'red';
                break;
            default:
                selectBox.style.borderColor = '#946CCF';
                selectBox.style.color = '#946CCF';
        }
    }

    updateStyles();
    selectBox.addEventListener('change', updateStyles);
}

    // jQuery part for handling modals
    $('.statusselectbox').on('change', function() {
        var selectedOption = $(this).find('option:selected'); // Get selected option
        var modalTarget = selectedOption.data('target'); // Get the modal target

        // Open the modal
        if(modalTarget) {
            $(modalTarget).modal('show');
        }
    });
//     $(document).on('click', '#dateFilterBtn', function(e) {
//         e.preventDefault();
//         $(this).closest('#dateFilterDropdown').addClass('show-date-dropdown');
//     })
//     $(document).on('click', '.date-item', function(e) {
//         e.preventDefault();
//         $(this).closest('#dateFilterDropdown').removeClass('show-date-dropdown');
//     })
//     $(document).on('click', '#customDateLink', function(e) {
//         e.preventDefault();
//         $(this).closest('.date-filter-dropdown').addClass('show-custom-date');
//   })

//   $('#exportBtn').click(function(){
//     $('.export-dropdown').toggleClass('show-dropdown');

// });

// $('.export-dropdown-btns button').click(function(){
//     $('.export-dropdown').toggleClass('show-dropdown');

// });

// For AI Chat Bot

$(document).on("click", ".ai-chat-bot-btn", function (e) {
  e.preventDefault();
  $(".ai-chat-bot").toggleClass("show-chat-bot");
});

$(document).on("click", ".chat-bat-zoom-btn", function (e) {
    e.preventDefault();
    $("body").toggleClass("body-no-scroll");
  $(".ai-chat-bot").toggleClass("chat-bot-zoomed");
});

$(document).on("click", ".chat-bat-minimize-btn", function (e) {
 
  $(".ai-chat-bot").removeClass("show-chat-bot");
    $(".ai-chat-bot").removeClass("chat-bot-zoomed");
    $("body").removeClass("body-no-scroll");
});
  
}


